import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation} from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import Invoice from './components/Invoice';
import Register from './components/Register';
import Login from './components/Login';
import Navbar from './components/Navbar';
import ViewPort from './components/ViewPort';
import { AuthProvider } from './AuthContext';
import History from './components/History';
import InvoiceApp from './components/InvoiceApp';
import Profile from './components/Profile';
import UnsettlePayment from './components/unsettlepyaments';
import Form from './components/form';


// Create a component that conditionally renders the Navbar
function AppContent() {
  const location = useLocation();
  
  // Don't show navbar on login and register pages
  const showNavbar = location.pathname !== '/login' && 
                     location.pathname !== '/' && 
                     location.pathname !== '/register';
  
  return (
    <div>
      {showNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/invoice" element={<Invoice />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/viewPort/:invoiceId" element={<ViewPort />} />
        <Route path="/history" element={<History />} />
        <Route path="/invoice-mobile" element={<InvoiceApp />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/unsettle" element={<UnsettlePayment />} />
        <Route path="/form" element={<Form />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;